import React from 'react';
import request from 'arcdynamic-request';
import {AGENTS} from '../../consts/tables';
import AgentForm from "../AgentForm/AgentForm";
import Alert from "../Alert";
import FirmDrawer from "../FirmDrawer/FirmDrawer";

export default class AgentDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            paneIndex: 0,
            isBusy: null,
            error: null,
            shouldOpenDrawer: false,
            newFirm: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.saveData = this.saveData.bind(this);
        this.addNewItem = this.addNewItem.bind(this);
        this.savedNewFirm = this.savedNewFirm.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.openDrawerCallback) {
            this.setState({shouldOpenDrawer: true});
        }
    }

    savedNewFirm(newData) {
        // select the new item id & close drawer
        const key = this.state.addNewItemType;
        const state = {
            data: {...this.state.data, [key]: newData.ARCIMEDES_ROW_ID},
            newFirm: newData
        };
        this.setState(state);
    }

    addNewItem() {
        this.setState({addNewItemType: 'FIRM'});

        const renderedComponent = () =>
            <FirmDrawer savedNewItem={this.savedNewFirm}
                        closeDrawer={this.state.shouldOpenDrawer ? this.props.closeChildDrawer : null}/>;

        if (this.state.shouldOpenDrawer)
            this.props.openDrawerCallback(renderedComponent);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.saveData();
    }

    handleChange(key, value) {
        const data = {...this.state.data};
        data[key] = value;
        this.setState({data});
    }

    handleDropdownChange(data) {
        this.setState({data});
    }

    saveData() {
        if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
        });

        return request(arc.path.api, {
            service: 'arcimedes',
            action: 'open.datasource.table.Data.updateByTableCode',
            params: [AGENTS, {
                value: [
                    this.state.data,
                ],
            }],
        }).then(res => {
            if (res && res.success) {
                this.setState({isBusy: false});
                this.props.savedNewItem(res.data[0], this.state.newFirm);

                if (this.props.closeDrawer) {
                    this.props.closeDrawer();
                    setTimeout(() => this.setState({data: {}, newFirm: false}), 1000);
                }
            } else {
                this.setState({
                    isBusy: null,
                    error: res && res.message ? res.message : 'Unspecified error',
                });
            }
        });
    }

    render() {
        const data = this.state.data;

        return (
            <React.Fragment>
                <AgentForm data={data}
                           paneIndex={this.state.paneIndex}
                           handleSubmit={this.handleSubmit}
                           handleCancel={this.props.closeDrawer}
                           handleParentChange={this.handleChange}
                           handleParentDropdownChange={this.handleDropdownChange}
                           handlePaneChange={(key) => this.setState({paneIndex: key})}
                           addNewItem={this.addNewItem}
                           newFirm={this.state.newFirm}
                />
                {this.state.error && <Alert type='error'>{this.state.error}</Alert>}
            </React.Fragment>
        );
    }
}

